import { useSiteInfo } from '@contexts/SiteInfoContext';
import React, {
    useState, useEffect, useRef,
} from 'react';
import SiteMapping from '@configs/siteMapping';
import { Icon } from '../common/Icon';
import LanguageContainer from '../common/LanguageContainer';
import PlatformContainer from '../common/PlatformContainer';
import headerLayout from '../../utils/headerLayout';

const DropdownClassName = {
    [SiteMapping.viva88]: { DROP_DOWN: 'dropdown' },
    [SiteMapping.bong88]: { DROP_DOWN: 'dropdown' },
    [SiteMapping.Nova88]: { DROP_DOWN: 'dropdown dropdown--primary' },
    [SiteMapping.IBCBet]: { DROP_DOWN: 'dropdown dropdown--primary' },
    [SiteMapping.PICA88]: { DROP_DOWN: 'dropdown dropdown--primary' },
    [SiteMapping.id8899]: { DROP_DOWN: 'dropdown dropdown--primary' },
    [SiteMapping.bettha88]: { DROP_DOWN: 'dropdown dropdown--primary' },
    [SiteMapping.taraPlays]: { DROP_DOWN: 'dropdown dropdown--primary' },
    [SiteMapping.fifabet]: { DROP_DOWN: 'dropdown dropdown--primary' },
    [SiteMapping.ocean99]: { DROP_DOWN: 'dropdown dropdown--primary' },
};

const DropdownButton = ({
    selectIconName, dropdownType, layoutType,
}) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdown = useRef(null);
    const { siteName } = useSiteInfo();
    const focusHandle = (event) => {
        if (!(dropdown.current && dropdown.current.contains(event.target))) {
            setDropdownOpen(false);
        }
    };

    useEffect(() => {
        if (dropdownOpen) {
            window.addEventListener('click', focusHandle);
        }

        return () => {
            window.removeEventListener('click', focusHandle);
        };
    }, [dropdownOpen]);

    return (
        <div
            role="desktop-visible"
            ref={dropdown}
            className={DropdownClassName[siteName].DROP_DOWN}
            data-open={dropdownOpen}
            onClick={() => setDropdownOpen(!dropdownOpen)}
        >
            <Icon
                siteName={siteName}
                dropdownType={dropdownType}
                selectIconName={selectIconName}
                layoutType={layoutType}
            />
            <div className="dropdown__container">
                {{
                    platform: <PlatformContainer layoutType={layoutType} />,
                    language: <LanguageContainer />,
                }[dropdownType]}
            </div>
        </div>
    );
};

export default DropdownButton;
